import script from "./Completed.vue?vue&type=script&setup=true&lang=js"
export * from "./Completed.vue?vue&type=script&setup=true&lang=js"

import "./Completed.vue?vue&type=style&index=0&id=27b700ee&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27b700ee"]])

export default __exports__